export default __webpack_public_path__ + "static/media/big-whale.7f1e0405.png";